import "./App.css";
import AgroAdminPanel from "./components/AgroAdminPanel";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Product from "./pages/Product";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import ImageUploader from "./pages/ImageUploader";
import ForgotPassword from "./pages/ForgotPassword";
import ChangePassword from "./pages/ChangePassword";
// import FileUpload from "./pages/Dummy";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="agroadminpanel" element={<AgroAdminPanel />} />
          <Route path="product" element={<Product />} />
          <Route path="orders" element={<div>Orders Page</div>} />
          <Route path="changepassword" element={<ChangePassword/>} />          
        </Route>
        <Route path="/logout" element={<LoginPage/>} />
        {/* <Route path="/dummy" element={<FileUpload />} /> */}
      </Routes>
    </div>
  );
}

export default App;
